import { Http } from '@/lib/http';

export class FollowUpActionsService extends Http {
  constructor() {
    super();
    this.endpoint = 'follow-up-actions';
  }

  getOptions(module) {
    return this.httpClient().get(`${this.endpoint}/options`, {
      params: { module }
    });
  }

  getForContext(context) {
    return this.httpClient().get(this.endpoint, { params: context });
  }

  getAssigned() {
    return this.httpClient().get(`${this.endpoint}/assigned`);
  }

  getAssignedPage(params) {
    return this.httpClient().get(`${this.endpoint}/assigned/page`, { params });
  }

  getAssignees() {
    return this.httpClient().get(`${this.endpoint}/assignees`);
  }

  respondAssignment(action, response, reason) {
    return this.httpClient().patch(`${this.endpoint}/${action.id}/assignment/response`, {
      assignmentVersion: action.assignmentVersion,
      response,
      ...(response === 'reject' ? { reason } : {})
    });
  }

  assign(action, assignedToId, assignmentNote) {
    return this.httpClient().patch(`${this.endpoint}/${action.id}/assignment`, {
      assignmentVersion: action.assignmentVersion,
      assignedToId,
      assignmentNote
    });
  }

  cancelAssignment(action) {
    return this.httpClient().patch(`${this.endpoint}/${action.id}/assignment/cancel`, {
      assignmentVersion: action.assignmentVersion
    });
  }

  create(action) {
    return this.httpClient().post(this.endpoint, action);
  }

  createBatch(actions) {
    return this.httpClient().post(`${this.endpoint}/batch`, actions);
  }

  createGlobalBatch(actions) {
    return this.httpClient().post(`${this.endpoint}/global/batch`, actions);
  }

  update(id, action) {
    return this.httpClient().patch(`${this.endpoint}/${id}`, action);
  }

  delete(id) {
    return this.httpClient().delete(`${this.endpoint}/${id}`);
  }

  updateStatus(id, status) {
    return this.httpClient().patch(`${this.endpoint}/${id}/status`, {
      status
    });
  }

  addComment(id, comment) {
    return this.httpClient().post(`${this.endpoint}/${id}/comments`, {
      comment
    });
  }

  updateComment(id, commentId, comment) {
    return this.httpClient().patch(`${this.endpoint}/${id}/comments/${commentId}`, {
      comment
    });
  }

  deleteComment(id, commentId) {
    return this.httpClient().delete(`${this.endpoint}/${id}/comments/${commentId}`);
  }
}
